import config from './config'

export const supportedLocales = [
  'en_GB',
  'en_US',
  'de_DE',
  'fr_FR',
  'es_ES',
  'zh_CN',
  'ja_JP',
  'pt_BR',
  'it_IT',
  'ko_KR',
]

export default function getLangLoader(locale) {
  // A runtime exception will be throw every time that the requested locale file
  // cannot be found. Webpack uses a regular expression to build all locales as
  // separate bundles.
  let localeToLoad = locale

  if (!supportedLocales.includes(locale)) {
    localeToLoad = config.default
  }

  const bundleLoader = import(`./${localeToLoad}.js`)

  return (callback) => bundleLoader.then((content) => callback(content.default))
}
